import type { HTMLAttributes, ReactNode } from 'react';
import { kaiFontFamily } from '../../../../core/tokens';
import {
  REVIEW_COLORS,
  REVIEW_ELEVATION,
  REVIEW_RADII,
  REVIEW_SPACING,
} from '../reviewFlowTokens';
import {
  resolveStyleOverride,
  type StyleOverride,
} from '../styleOverrides';

export interface ModalLayoutProps extends HTMLAttributes<HTMLDivElement> {
  mediaPane: ReactNode;
  detailPane: ReactNode;
  styleOverride?: StyleOverride;
}

export const ModalLayout = ({
  mediaPane,
  detailPane,
  styleOverride: layoutCss,
  style,
  ...props
}: ModalLayoutProps) => {
  return (
    <div
      data-review-flow-detail-modal-layout='true'
      style={{
        position: 'fixed',
        inset: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: REVIEW_SPACING.xxLarge,
        background: 'rgba(18, 18, 20, 0.58)',
        zIndex: 1000,
      }}
      {...props}
    >
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'minmax(0, 1.35fr) minmax(340px, 1fr)',
          width: '100%',
          maxWidth: 1200,
          maxHeight: '92vh',
          overflow: 'hidden',
          borderRadius: REVIEW_RADII.xLarge,
          background: REVIEW_COLORS.surface,
          boxShadow: REVIEW_ELEVATION.overlay,
          fontFamily: kaiFontFamily,
          ...style,
          ...resolveStyleOverride(layoutCss),
        }}
      >
        {mediaPane}
        {detailPane}
      </div>
    </div>
  );
};
